import Flag from 'components/Flag/Flag';

export default Flag;
